@if (!successfulBooking) {
  <div role="alert" aria-live="assertive">
    <div class="row justify-content-md-center cb-error-layout">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <app-alert
          [title]="errTitleOut | translate"
          [text]="bookingErrorMessage ? bookingErrorMessage : errMsgOut"
          type="danger"
          [dismissableButton]="false"
        />
        @if (showRefundNotice()) {
          <app-alert
            type="info"
            [text]="refundNoticeKey() | translate: { transactionId: refundTransactionId() }"
            [dismissableButton]="false"
          />
        }
      </div>
    </div>
  </div>
}

@if (successfulBooking) {
  <div class="mt-5" role="region" aria-label="Booking Confirmation">
    <div class="d-flex flex-column align-items-center">
      <div 
        class="cbw-final-page-title mt-4"
        [innerHtml]="successTitleTemplate | translation: templateContent.TEMPLATE_CONTENT: lang | trustHtml"
        role="heading"
        aria-level="1"
      ></div>
      @if (successFullBookings?.length !== 0) {
        @if (successFullBookings?.length === 1) {
          @for (booking of successFullBookings; track booking) {
            <ng-container *ngTemplateOutlet="singleBookingTemplate; context:{ booking: booking }" />
          }
        }
        @if (successFullBookings?.length > 1) {
          <ng-container *ngTemplateOutlet="multipleBookingTemplate; context:{ bookings: successFullBookings }" />
        }
      }
      @if (successFullBookings?.length === 0 && bookingLimitReached) {
        <ng-container *ngTemplateOutlet="limitReachedTemplate" />
      }
    </div>
  </div>
}

<ng-template #singleBookingTemplate let-booking="booking">
  @if (!bookingLimitReached) {
    <div
      class="cbw-final-page-message mt-4 px-3 text-center"
      [innerHtml]="(successMsgOut | replaceTemplatePlaceholder: booking?.selectedStore) | trustHtml"
      role="status"
      aria-live="polite"
    ></div>
  }
  @if (bookingLimitReached) {
    <div
      class="cbw-final-page-message mt-4 px-3 text-center"
      [innerHtml]="widgetSuccessPageEventBookingLimitReachedTemplate | translation: templateContent.TEMPLATE_CONTENT: lang | trustHtml"
      role="status"
      aria-live="polite"
    ></div>
  }

  @if (booking?.landingPageLink) {
    <div class="cbw-final-page-link mt-4 px-3 text-center" role="navigation" aria-label="Booking Actions">
      <div>
        <a 
          href="{{ booking?.landingPageLink }}" 
          target="_blank" 
          [attr.aria-label]="manageAppointmentNowTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
        >
          <span>
            {{ manageAppointmentNowTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}
          </span>
        </a>
      </div>
      @if (downloadBookingDetailTemplate) {
        <div class="mt-2">
          <a
            href="javascript:void(0)"
            (click)="downloadBookingDetail(booking?.bookingUUID)"
            [attr.aria-label]="downloadBookingDetailTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
          >
            <span class="d-flex align-items-center justify-content-center">
              <span class="pe-1" aria-hidden="true">
                <fa-icon class="icon" icon="download"></fa-icon>
              </span>
              <span>{{ downloadBookingDetailTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}</span>
            </span>
          </a>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #multipleBookingTemplate let-bookings="bookings">
  @if (!bookingLimitReached) {
    <div
      class="cbw-final-page-message mt-4 px-3 text-center"
      [innerHtml]="(successMsgOut | replaceTemplatePlaceholder: bookings[0]?.selectedStore) | trustHtml"
      role="status"
      aria-live="polite"
    ></div>
  }
  @if (bookingLimitReached) {
    <div 
      class="cbw-final-page-message mt-4 px-3 text-center"
      [innerHtml]="widgetSuccessPageEventBookingLimitReachedTemplate | translation: templateContent.TEMPLATE_CONTENT: lang | trustHtml"
      role="status"
      aria-live="polite"
    >
    </div>
  }

  <div 
    class="cbw-final-page-link mt-4 px-3 text-center" 
    role="navigation" 
    aria-label="Multiple Booking Actions"
  >
    <div class="d-flex justify-content-center flex-wrap">
      <span>
        {{ manageAppointmentNowTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}:
      </span>

      @for (booking of bookings; track booking; let index = $index; let last = $last) {
        <a
          class="ps-1"
          href="{{ booking?.landingPageLink }}" 
          target="_blank"
          [attr.aria-label]="('appointments.step3.appointment' | translate) + ' ' + (index + 1)"
        >
          {{ ('appointments.step3.appointment' | translate) + ' ' + (index + 1) + (last ? '' : ', ') }}
        </a>
      }
    </div>
    @if (downloadBookingDetailTemplate) {
      <div class="mt-2">
        <div class="d-flex justify-content-center flex-wrap">
          <span class="d-flex align-items-center justify-content-center">
            <span class="pe-1" aria-hidden="true">
              <fa-icon class="icon" icon="download"></fa-icon>
            </span>
            <span>{{ downloadBookingDetailTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}:</span>
          </span>
          @for (booking of bookings; track booking; let index = $index; let last = $last) {
            <a
              class="ps-1"
              href="javascript:void(0)"
              (click)="downloadBookingDetail(booking?.bookingUUID)"
              [attr.aria-label]="downloadBookingDetailTemplate | translation: templateContent.TEMPLATE_CONTENT: lang + ' ' + ('appointments.step3.appointment' | translate) + ' ' + (index + 1)"
            >
              {{ ('appointments.step3.appointment' | translate) + ' ' + (index + 1) + (last ? '' : ', ') }}
            </a>
          }
        </div>
      </div>
    }
  </div>
</ng-template>

<ng-template #limitReachedTemplate>
  <div
    class="cbw-final-page-message mt-4 px-3 text-center"
    [innerHtml]="widgetSuccessPageEventBookingLimitReachedTemplate | translation: templateContent.TEMPLATE_CONTENT: lang | trustHtml"
    role="status"
    aria-live="polite"
  >
  </div>
</ng-template>
